<template>
  <CustomPicker
    inputId="independent-lesson-picker"
    title="title"
    placeholder="درس را انتخاب کنید"
    inputLabel="انتخاب درس مورد نظر"
    :isInDialog="isInDialog"
    :closeOnSelect="closeOnSelect"
    :isDisabled="isDisabled"
    :items="lessonsList"
    :multiple="isMultiple"
    :reduce="(lesson) => lesson.id"
    v-model="selectedLesson"
    @search="handleSearch"
    @open="onOpen"
    @close="onClose"
  >
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">در حال لود...</li>
    </template>
  </CustomPicker>
</template>
<script>
import { GetIndependentLessonsList } from "@/libs/Api/IndependentLesson";

export default {
  emits: ["getLesson"],
  props: {
    closeOnSelect: {
      type: Boolean,
      required: false,
      default: false,
    },
    isInDialog: {
      type: Boolean,
      default: false,
    },
    languageId: {
      type: [String, Number, null],
      default: null,
    },
    defaultLessonId: {
      type: [Number, String, Array, null],
      required: false,
      default: null,
    },
    defaultCourseId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    isMultiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    this.getAllLessons();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  watch: {
    selectedLesson: {
      handler(val) {
        this.$emit("getLesson", val);
      },
    },
    languageId: {
      handler(val) {
        this.getAllLessons();
      },
    },
    defaultCourseId: {
      handler(val) {
        if (val && val != "" && val != 0) {
          this.getAllLessons();
        }
      },
    },
  },
  data() {
    return {
      lessonsList: null,
      selectedLesson: null,
      searchVal: null,
      timeout: null,
      observer: null,
      totalCount: null,
      lessonsListFilters: {
        pageNumber: 1,
        count: 200,
        title: null,
        languageId: null,
      },
    };
  },
  methods: {
    async onOpen() {
      if (this.hasNextPage) {
        this.$nextTick(() => {
          this.observer.observe(this.$refs.load);
        });
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.lessonsListFilters.pageNumber++;
          this.getAllLessons(true);
        }
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    clearSelectedLesson() {
      this.selectedLesson = null;
    },
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.lessonsListFilters.title = searchValue;
        loadingFn(true);
        await this.getAllLessons();
        loadingFn(false);
      }, 300);
    },
    async getAllLessons(isLoadMore = false) {
      try {
        this.lessonsListFilters.languageId = this.languageId;
        let _this = this;
        let getIndependentLessonsList = new GetIndependentLessonsList(_this);
        getIndependentLessonsList.setRequestParamDataObj(
          _this.lessonsListFilters
        );
        await getIndependentLessonsList.fetch(function (response) {
          if (isLoadMore) {
            _this.lessonsList.push(...response.data);
          } else {
            _this.lessonsList = response.data;
          }
          _this.totalCount = response.total;
          if (_this.defaultLessonId) {
            _this.selectedLesson = _this.defaultLessonId;
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  computed: {
    hasNextPage() {
      if (
        this.totalCount &&
        this.totalCount / this.lessonsListFilters.count >
          this.lessonsListFilters.pageNumber
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    CustomPicker,
  },
};
import CustomPicker from "@/views/components/Utils/CustomPicker.vue";
</script>
